import React, { useState } from "react";
import useDiagramacaoForm from "./hooks/useDiagramacaoForm";
import DiagramacaoForm from "./components/DiagramacaoForm/DiagramacaoForm";
import DiagramacaoPreview from "./components/DiagramacaoPreview/DiagramacaoPreview";
import { useTests } from "../../../hooks/test/useTests";
import { TestDetails } from "../../../hooks/test/types/types";
import ModalFormula from "./components/ModalFormula/ModalFormula";


//*Import hooks from react-router-dom
import { useParams } from "react-router-dom";


export default function CriarDiagramacao({ editMode }: { editMode?: boolean }) {
  const token = localStorage.getItem("token") || "";

  const params = useParams();
  const id = params.id;
  const { test: provas, loading: loadingTests, getTestById } = useTests(token);

  // Hook de diagramação
  const {
    loading,
    setLoading,
    msgErro,
    nameTestSelect,
    setMsgErro,
    provaSelect,
    setProvaSelect,
    nomeProva,
    setNomeProva,
    numeroColunas,
    setNumeroColunas,
    fontSizeQuestoes,
    setFontSizeQuestoes,
    marginSuperior,
    setMarginSuperior,
    marginInferior,
    setMarginInferior,
    marginEsquerda,
    setMarginEsquerda,
    marginDireita,
    setMarginDireita,
    questionPages,
    setQuestionPages,
    handleSave,
    // Campos básicos
    nickNameLayout,
    setNickNameLayout,
    title,
    setTitle,
    subtitle,
    setSubtitle,
    titleHeader,
    setTitleHeader,
    subtitleHeader,
    setSubtitleHeader,
    // Logos
    logo,
    setLogo,
    logoBottom,
    setLogoBottom,
    // Configurações de fonte
    fontSizeRules,
    setFontSizeRules,
    fontSizeAlternatives,
    setFontSizeAlternatives,
    // Configurações de layout
    numberColumnsRules,
    setNumberColumnsRules,
    showDiscipline,
    setShowDiscipline,
    borderVisible,
    setBorderVisible,
    // Configurações de randomização
    randomQuestion,
    setRandomQuestion,
    randomAlternatives,
    setRandomAlternatives,
    randomPerCategory,
    setRandomPerCategory,
    selectFromGroup,
    setSelectFromGroup,
    numberSelectQuestions,
    setNumberSelectQuestions,
    // Configurações da folha de resposta
    titleAnswer,
    setTitleAnswer,
    subtitleAnswer,
    setSubtitleAnswer,
    nameAnswer,
    setNameAnswer,
    answerPageVisible,
    setAnswerPageVisible,
    rules,
    setRules,
    rulesAnswer,
    setRulesAnswer,
    // Configurações de layout padrão
    defaultLayout,
    setDefaultLayout,
    nameDefault,
    setNameDefault,
    //elementos
    dataFrontPage,
    setDataFrontPage,
  } = useDiagramacaoForm({ token, editMode, id });

  // Estado do modal de fórmula
  const [showModalFormula, setShowModalFormula] = useState(false);

  const handleInsertFormula = (imgUrl: any, html: any) => {
    setShowModalFormula(false);
  };

  // Se quiser juntar estados de loading:
  const isPageLoading = loading || loadingTests;

  return (
    <div className="container mt-4">
      <h2 className="hidethis">Diagramar Prova</h2>

      <DiagramacaoForm
        provas={provas}
        nomeProva={nomeProva}
        provaSelect={provaSelect}
        nameTestSelect={nameTestSelect}
        setProvaSelect={
          setProvaSelect as React.Dispatch<
            React.SetStateAction<TestDetails | null>
          >
        }
        setNomeProva={setNomeProva}
        numeroColunas={numeroColunas}
        setNumeroColunas={setNumeroColunas}
        fontSizeQuestoes={
          fontSizeQuestoes === "default" ? 12 : fontSizeQuestoes
        }
        setFontSizeQuestoes={setFontSizeQuestoes}
        marginSuperior={marginSuperior}
        setMarginSuperior={setMarginSuperior}
        marginInferior={marginInferior}
        setMarginInferior={setMarginInferior}
        marginEsquerda={marginEsquerda}
        setMarginEsquerda={setMarginEsquerda}
        marginDireita={marginDireita}
        setMarginDireita={setMarginDireita}
        handleSave={handleSave}
        loading={isPageLoading}
        setLoading={setLoading}
        msgErro={msgErro}
        setMsgErro={setMsgErro}
        getTestById={getTestById}
        // Novos campos
        codeExam={nickNameLayout}
        setCodeExam={setNickNameLayout}
        title={title}
        setTitle={setTitle}
        subtitle={subtitle}
        setSubtitle={setSubtitle}
        titleHeader={titleHeader}
        setTitleHeader={setTitleHeader}
        subtitleHeader={subtitleHeader}
        setSubtitleHeader={setSubtitleHeader}
        logo={logo}
        setLogo={setLogo}
        logoBottom={logoBottom}
        setLogoBottom={setLogoBottom}
        fontSizeRules={fontSizeRules}
        setFontSizeRules={setFontSizeRules}
        fontSizeAlternatives={fontSizeAlternatives}
        setFontSizeAlternatives={setFontSizeAlternatives}
        numberColumnsRules={numberColumnsRules}
        setNumberColumnsRules={setNumberColumnsRules}
        showDiscipline={showDiscipline}
        setShowDiscipline={setShowDiscipline}
        borderVisible={borderVisible}
        setBorderVisible={setBorderVisible}
        randomQuestion={randomQuestion}
        setRandomQuestion={setRandomQuestion}
        randomAlternatives={randomAlternatives}
        setRandomAlternatives={setRandomAlternatives}
        randomPerCategory={randomPerCategory}
        setRandomPerCategory={setRandomPerCategory}
        selectFromGroup={selectFromGroup}
        setSelectFromGroup={setSelectFromGroup}
        numberSelectQuestions={numberSelectQuestions}
        setNumberSelectQuestions={setNumberSelectQuestions}
        titleAnswer={titleAnswer}
        setTitleAnswer={setTitleAnswer}
        subtitleAnswer={subtitleAnswer}
        setSubtitleAnswer={setSubtitleAnswer}
        nameAnswer={nameAnswer}
        setNameAnswer={setNameAnswer}
        answerPageVisible={answerPageVisible}
        setAnswerPageVisible={setAnswerPageVisible}
        rules={rules}
        setRules={setRules}
        rulesAnswer={rulesAnswer}
        setRulesAnswer={setRulesAnswer}
        defaultLayout={defaultLayout}
        setDefaultLayout={setDefaultLayout}
        nameDefault={nameDefault}
        setNameDefault={setNameDefault}
        DataFrontPage={dataFrontPage}
        setDataFrontPage={setDataFrontPage}
        editMode={editMode}
      />

      <DiagramacaoPreview
        provas={provas}
        provaSelect={provaSelect}
        questionPages={questionPages}
        setQuestionPages={setQuestionPages}
        setProvaSelect={
          setProvaSelect as React.Dispatch<
            React.SetStateAction<TestDetails | null>
          >
        }
        nomeProva={nomeProva}
        setNomeProva={setNomeProva}
        numeroColunas={numeroColunas}
        setNumeroColunas={setNumeroColunas}
        fontSizeQuestoes={
          fontSizeQuestoes === "default" ? 12 : fontSizeQuestoes
        }
        setFontSizeQuestoes={setFontSizeQuestoes}
        marginSuperior={marginSuperior}
        setMarginSuperior={setMarginSuperior}
        marginInferior={marginInferior}
        setMarginInferior={setMarginInferior}
        marginEsquerda={marginEsquerda}
        setMarginEsquerda={setMarginEsquerda}
        marginDireita={marginDireita}
        setMarginDireita={setMarginDireita}
        handleSave={handleSave}
        loading={isPageLoading}
        setLoading={setLoading}
        msgErro={msgErro}
        setMsgErro={setMsgErro}
        getTestById={getTestById}
        // Novos campos
        nickNameLayout={nickNameLayout}
        setNickNameLayout={setNickNameLayout}
        title={title}
        setTitle={setTitle}
        subtitle={subtitle}
        setSubtitle={setSubtitle}
        titleHeader={titleHeader}
        setTitleHeader={setTitleHeader}
        subtitleHeader={subtitleHeader}
        setSubtitleHeader={setSubtitleHeader}
        logo={logo}
        setLogo={setLogo}
        logoBottom={logoBottom}
        setLogoBottom={setLogoBottom}
        fontSizeRules={fontSizeRules}
        setFontSizeRules={setFontSizeRules}
        fontSizeAlternatives={fontSizeAlternatives}
        setFontSizeAlternatives={setFontSizeAlternatives}
        numberColumnsRules={numberColumnsRules}
        setNumberColumnsRules={setNumberColumnsRules}
        showDiscipline={showDiscipline}
        setShowDiscipline={setShowDiscipline}
        borderVisible={borderVisible}
        setBorderVisible={setBorderVisible}
        randomQuestion={randomQuestion}
        setRandomQuestion={setRandomQuestion}
        randomAlternatives={randomAlternatives}
        setRandomAlternatives={setRandomAlternatives}
        randomPerCategory={randomPerCategory}
        setRandomPerCategory={setRandomPerCategory}
        selectFromGroup={selectFromGroup}
        setSelectFromGroup={setSelectFromGroup}
        numberSelectQuestions={numberSelectQuestions}
        setNumberSelectQuestions={setNumberSelectQuestions}
        titleAnswer={titleAnswer}
        setTitleAnswer={setTitleAnswer}
        subtitleAnswer={subtitleAnswer}
        setSubtitleAnswer={setSubtitleAnswer}
        nameAnswer={nameAnswer}
        setNameAnswer={setNameAnswer}
        answerPageVisible={answerPageVisible}
        setAnswerPageVisible={setAnswerPageVisible}
        rules={rules}
        setRules={setRules}
        rulesAnswer={rulesAnswer}
        setRulesAnswer={setRulesAnswer}
        defaultLayout={defaultLayout}
        setDefaultLayout={setDefaultLayout}
        nameDefault={nameDefault}
        setNameDefault={setNameDefault}
        DataFrontPage={dataFrontPage}
        setDataFrontPage={setDataFrontPage}
        editMode={editMode}
        
      />

      <ModalFormula
        showModal={showModalFormula}
        setShowModal={setShowModalFormula}
        setImage={handleInsertFormula}
      />

      
    </div>
  );
}
